module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Конфіденційність",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Відмова",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Конфігуратор GROHE WaterSystems",
	"homepage.introtext": "Дайте відповіді на декілька запитань нижче, щоб скомпонувати систему води GROHE, яка задовольнить Ваші потреби.",
	"homepage.buttonStart": "Розпочати",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Сторінку не знайдено",
	"404.link.goBack": "Повернутися на стартову сторінку",
	"configurator.button.seeResults": "Дивитися результат",
	"question1.question": "Чи є у Вас холодне та гаряче водопостачання на кухні?",
	"question1.option1.text": "У мене є холодне та гаряче водопостачання на кухні",
	"question1.option2.text": "У мене є лише холодне водопостачання",
	"question2.question": "Яка саме вода Вам необхідна?",
	"question2.option1.text": "Кипляча вода для приготування іжі та напоїв",
	"question2.option2.text": "Прохолодна та газована питна вода",
	"question2.option3.text": "Прохолодна, газована, а також кипляча вода",
	"question3.question": "Ви хочете залишити існуючий кухонний змішувач?",
	"question3.option1.text": "Хочу залишити існуючий",
	"question3.option2.text": "Хочу встановити новий",
	"question4.question": "Який із змішувачів має бути основним?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Якій формі виливу Ви надаєте перевагу?",
	"question5.option1.text": "L-подібний вилив",
	"question5.option2.text": "U-подібний вилив",
	"question5.option3.text": "C-подібний вилив",
	"question6.question": "Якому типу покриття поверхні змішувача Ви надаєте перевагу?",
	"question6.option1.text": "Хром",
	"question6.option2.text": "Дамаська сталь",
	"question7.question": "Який розмір бойлер Вам необхіден?",
	"question7.option1.text": "Розмір М (3 літри)",
	"question7.option2.text": "Розмір L (5.5 літри)",
	"results.title": "{productGroupsCount, plural, \none {Ваш результат} \nother {Ваші результати}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Для правильного проведення монтажу Вам також знадобляться:",
	"results.newConfiguration.title": "Хотіли б скомпонувати нову систему води?",
	"results.newConfiguration.buttonText": "Розпочати новий підбір системи води",
	"results.product.number": "Артикул: #{number}",
	"results.product.button.productInformation": "Інформація про продукт",
	"results.product.button.dealerLocator": "Знайти салон-магазин",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Інформація про продукт",
	"results.product.dealer": "Знайти салон-магазин",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.uk_ua.json
// module id = 797
// module chunks = 0